import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { DashboardResponse } from '../types/Dashboard';
import { fetchJson } from '@/utils/apiFetch';

/**
 * ダッシュボード本日分（job_change_processes + notices）を取得するフック。
 * `organizationUserId` を渡すと担当者で絞り込む。
 */
export default function useFetchDashboard(organizationUserId?: string) {
  const query = qs.stringify(
    organizationUserId ? { organization_user_id: organizationUserId } : {},
    { arrayFormat: 'brackets' }
  );
  return useQuery({
    queryKey: ['dashboard', query],
    queryFn: async () => {
      const data = await fetchJson<DashboardResponse>(`/agent/api/dashboard.json?${query}`);

      return data;
    },
  });
}
